import axios from "../../utils/axios";

export const giveLikesUnlikes = async (
  id,
  likesOrUnlikesNo,
  likesOrUnlikes
) => {
  const response = await axios.patch(`/videos/${id}`, {
    [likesOrUnlikes]: likesOrUnlikesNo,
  });
  return response.data;
};

export const getLiksUnlikes = async (id) => {
  const response = await axios.get(`/videos/${id}`);
  return response.data;
};
